import { render, staticRenderFns } from "./AuthoriseOtherLabourOld.vue?vue&type=template&id=16ddee7c&scoped=true"
import script from "./AuthoriseOtherLabourOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseOtherLabourOld.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseOtherLabourOld.vue?vue&type=style&index=0&id=16ddee7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddee7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ddee7c')) {
      api.createRecord('16ddee7c', component.options)
    } else {
      api.reload('16ddee7c', component.options)
    }
    module.hot.accept("./AuthoriseOtherLabourOld.vue?vue&type=template&id=16ddee7c&scoped=true", function () {
      api.rerender('16ddee7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseOtherLabourOld.vue"
export default component.exports